import React from "react";
import { profileContactLogFollowUpsData } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import AttachFileModal from "../common/AttachFileModal";
import { StoryBookIcon } from "../common/Icon";

const ProfileContactLogFollowUps = () => {
  const { profileAttachFileModal, setprofileAttachFileModal } =
    useStateProvider(); //ATTACH FILE MODAL

  // Function to show the Attach File MODAL
  const openMeetingAttachFileModal = () => {
    setprofileAttachFileModal(true);
  };
  return (
    <>
      <div className=" pb-[50px] h-full flex flex-col relative">
        <div>
          {profileContactLogFollowUpsData.map((value, index) => (
            <div
              className=" w-[600px] md:w-auto p-[16px_20px] rounded-md bg-[#F6F6F6] hover:shadow-workflow_item_card_shadow duration-300 mb-[10px]"
              key={index}>
              <div className=" flex justify-between items-center">
                <div className="fle flex-col">
                  <p className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                    <span className="text-xs 3xl:text-[16px] font-medium text-black opacity-70 pr-2">
                      Date:
                    </span>
                    {value.followUpsFullDate}
                  </p>
                  <p className="text-[10px] 3xl:text-[14px] font-normal text-gray pt-[6px]">
                    <span className="text-xs 3xl:text-[16px] font-medium text-black opacity-70 pr-2">
                      Time:
                    </span>
                    {value.followUpsTime}
                  </p>
                </div>
                <div className=" flex items-center gap-2">
                  <button className="rounded-full border-[0.688px] border-solid border-[rgba(0,_0,_0,_0.10)] bg-white p-1 hover:bg-primary story-book-icon duration-200">
                    <StoryBookIcon />
                  </button>

                  <button
                    onClick={openMeetingAttachFileModal}
                    className="text-[10px] 3xl:text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary p-[4px_10px] hover:bg-primary hover:text-white hover:border-transparent duration-200">
                    + Attach File
                  </button>
                </div>
              </div>

              <p className="text-[14px] font-normal text-black pt-[10px] opacity-70">
                {value.followUpsText}
              </p>
            </div>
          ))}
        </div>

        <div className="fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[8%] z-[9999] 3xl:top-[33%] 3xl:right-[6%]">
          {profileAttachFileModal && (
            <AttachFileModal
              attachFileModal={profileAttachFileModal}
              setAttachFileModal={setprofileAttachFileModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileContactLogFollowUps;
